/**
 * Login form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import { CustomFormInput } from 'Common/Form';
import { requiredValidation } from 'Utils';
import Button from 'Common/CustomButtons/Button';
import GridContainer from 'Common/Grid/GridContainer.jsx';
import ItemGrid from 'Common/Grid/ItemGrid.jsx';
import styles from './styles.jsx';
import CardActions from '@material-ui/core/CardActions';

@withStyles(styles)
@reduxForm({
    form: 'login',
})
export default class LoginForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        pristine: PropTypes.bool,
        invalid: PropTypes.bool,
        classes: PropTypes.object.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    render() {
        const { handleSubmit, pristine, invalid, classes } = this.props;

        return (
            <form onSubmit={handleSubmit} id="login" className={classes.form}>
                <Field
                    className="inpLogin"
                    name="email"
                    component={CustomFormInput}
                    type="email"
                    label={'field.email.label'}
                    maxLength={254}
                    placeholder="email"
                    validate={[requiredValidation]}
                />
                <Field
                    name="password"
                    component={CustomFormInput}
                    type="password"
                    label={'field.password.label'}
                    maxLength={254}
                    placeholder="password"
                    validate={[requiredValidation]}
                />
                <GridContainer>
                    <ItemGrid xs={12} sm={12} md={6}>
                    </ItemGrid>
                    <ItemGrid xs={12} sm={12} md={6} className="customClassColor right-text-wrap">
                        <Link to="/recover" className="d-block mg-b-10 tx-12 tx-info " tabIndex="-1">
                            <FormattedMessage id="button.password.reset" />
                        </Link>
                    </ItemGrid>
                    {/*<ItemGrid xs={12} sm={12} md={6} className='customClass customClassColor'>
                        <Link to="/register" className="d-block mg-b-10 tx-12 tx-info " tabIndex="-1 ">
                            <FormattedMessage id="button.register" />
                        </Link>
                    </ItemGrid>*/}
                </GridContainer>
                <CardActions className={classes.cardActions + ' ' + classes.alignCenter + ' loginSubmit'}>
                    <Button round wd size="lg" color="primary" disabled={pristine || invalid} type="submit" >
                        <FormattedMessage id="button.login" />
                    </Button>
                </CardActions>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Login/LoginForm.jsx